import { Button } from '@korint/folio';
import { Link } from 'react-router-dom';

export const SuperAdminView = () => {
  return (
    <h1 className="flex flex-col items-center justify-center h-screen text-4xl font-bold text-primary">
      <div>
        Garantie Plus
        <div className="flex flex-col items-start">
          <Button variant="link" className="px-0" size="sm">
            <Link to="/auth/sign-in">Sign in</Link>
          </Button>
          <Button variant="link" className="px-0" size="sm">
            <Link to="/brokerage-firm/creation">Brokerage Firm creation funnel</Link>
          </Button>
          <Button variant="link" className="px-0" size="sm">
            <Link to="/brokerage-firm-list">Espace Garantie Plus</Link>
          </Button>
          <Button variant="link" className="px-0" size="sm">
            <Link to="/intermediary-users-list">Espace garage</Link>
          </Button>
        </div>
      </div>
    </h1>
  );
};
